export default __webpack_public_path__ + "static/media/books2-afterA-1440w.f5e12688.webp";